import { plural } from '@cian/utils/lib/shared/plural';
import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import { RailwayIcon } from '../railway_icon';
import { isDefined } from '../../../utils/isDefined';
import { IRailway } from '../../../types/offer';

const styles = require('./index.css');

export interface IRailwayProps {
  railway: IRailway;
  hideDot?: boolean;
}

const INTERPUNCT = '\u22C5';

export const Railway: React.StatelessComponent<IRailwayProps> = ({ railway, hideDot }) => {
  return (
    <div {...mergeStyles(styles['railway-container'])}>
      <div className={styles['icons']}>
        <RailwayIcon
          width={16}
          height={16}
        />
      </div>
      <div {...mergeStyles(styles['railway-name'])}>
        {railway.name}
      </div>
      {!hideDot && INTERPUNCT}
      {
        isDefined(railway.time) && railway.time > 0 &&
          <div className={styles['remoteness']}>
            {railway.time}&nbsp;
            {plural(railway.time, ['минута', 'минуты', 'минут'])}&nbsp;
            {railway.travelType === 'byFoot' ? 'пешком' : 'на транспорте'}
          </div>
      }
    </div>
  );
};
